import Axios from "axios";
import React, { useContext, useEffect, useState, useRef } from "react";
import AuthContainer from "../../../../components/AuthContainer";
import AppContext from "../../../../context/store";
import Button from "../../../../theme/Button";
import { Grid, Column } from "../../../../theme/Grid";
import {
  Card,
  CardContent,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import { FeaturedPlayList, WhatsApp } from "@material-ui/icons";
import styled from "styled-components";
import FCLabel from "../../../../theme/FCLabel";
import { Alert } from "@material-ui/lab";
import { toast } from "react-toastify";
import CalculateMessageCharCount from "../../../../functions/CalculateMessageCharCount";
import CalculateMessageCount from "../../../../functions/CalculateMessageCount";
import ESignatureRequiredOverlay from "../../../../components/Alerts/ESignatureRequiredOverlay";
import useESignatureSocket from "../../../../hooks/useESignatureSocket";
import MobileSignatureDeviceButton from "../../../../components/MobileSignatureDeviceButton";

const StatsCardContainer = styled.div`
  position: relative;
  display: block;
  box-sizing: border-box;
  overflow: hidden;
  width: 100%;
  min-height: 73px;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04);
`;

const IconAlignContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
  border-radius: 5px;
`;

const TextAlignContainer = styled.div`
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 0 24px;

  @media (max-width: 768px) {
    align-items: center;
    text-align: center;
    padding: 16px;
  }
`;

const StatsHeader = styled.h1`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  margin: 0;
  padding: 0;
  color: #aaa;
  padding-bottom: 10px;
`;

const StatsTitle = styled.h3`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin: 0;
  padding: 0;
  color: #a0a0a0;
`;

const StatsValue = styled.p`
  font-weight: 600;
  font-size: 20px;
  line-height: 1.2;
  margin: 0;
  padding: 0;
`;

const BirthDaySms = () => {
  const context = useContext(AppContext);
  const [message, setMessage] = useState("");
  const [sender, setSender] = useState("");
  const [loading, setLoading] = useState(false);
  const [isFormDisabled, setIsFormDisabled] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [shortCode, setShortCode] = useState("");
  const { eSignatureConnected, certificateExpired, certificateExpiredDate, nationalIdMissing, tcMismatch, mobileSignIn, mobileLoading, mobileError } = useESignatureSocket();
  const messageRef = useRef(null);



  const getMessageSettings = () => {
    Axios.get(`${context.api_endpoint}/company/message/credit`).then(
      ({ data }) => {
        setSender(data.data.settings.sender);
        setShortCode(data.data.settings.shortCode || "");
        if (
          data.data.settings.sender === "" ||
          data.data.settings.sender === null
        ) {
          setIsFormDisabled(true);
        } else {
          setIsFormDisabled(false);
        }
      }
    ).catch((error) => {
      console.error("Error fetching message settings:", error);
      setIsFormDisabled(true);
    });
  };

  const fetchBirthdayMessage = () => {
    setFetching(true);
    Axios.get(`${context.api_endpoint}/company/message/birthdaymsg`)
      .then(({ data }) => {
        if (data && data.data && data.data.message !== undefined && data.data.message !== null) {
          setMessage(data.data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching birthday message:", error);
      })
      .finally(() => {
        setFetching(false);
      });
  };

  const saveBirthdayMessage = () => {
    if (!message.trim()) {
      toast.error("Lütfen bir mesaj giriniz!");
      return;
    }

    setLoading(true);
    Axios.post(`${context.api_endpoint}/company/message/birthdaymsg`, {
      message: message.trim()
    })
      .then(({ data }) => {
        if (data.status === 200) {
          fetchBirthdayMessage();
          toast.success("Doğum günü mesajınız başarıyla kaydedildi!");
        } else {
          toast.error(data.message || "Bir hata oluştu!");
        }
      })
      .catch((error) => {
        console.error("Error saving birthday message:", error);
        toast.error("Mesaj kaydedilirken bir hata oluştu!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getMessageSettings();
    fetchBirthdayMessage();
  }, []);

  return (
    <AuthContainer>
      <Grid className="mb-2">
        <Column className="xs-12 sm-12 md-3">
          <StatsCardContainer>
            <Grid style={{ height: "100%", minHeight: 73 }} className="no-gutters-all">
              <Column>
                <IconAlignContainer style={{ backgroundColor: "#fff3e0", color: "#f57c00" }}>
                  <FeaturedPlayList style={{ fontSize: "2em" }} />
                </IconAlignContainer>
              </Column>
              <Column>
                <TextAlignContainer>
                  <StatsHeader>{context.t(`["sms/filter"].smsMessageTitle`)}</StatsHeader>
                  <StatsValue>{sender}</StatsValue>
                </TextAlignContainer>
              </Column>
            </Grid>
          </StatsCardContainer>
        </Column>
      </Grid>

      {isFormDisabled && (
        <Grid className="mb-2">
          <Column className="xs-12">
            <Alert severity="error">
              <b>Gönderici adınız olmadığı için özel doğum günü mesajı giremezsiniz!</b>
              <br />
              Doğum günü mesajı gönderebilmek için öncelikle SMS ayarlarından gönderici adınızı tanımlamanız gerekmektedir.
            </Alert>
          </Column>
        </Grid>
      )}

      {process.env.APP_NAME !== "management" && (
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
          <MobileSignatureDeviceButton />
        </div>
      )}

      <div style={{ position: "relative" }}>
        {!eSignatureConnected ? (
          <ESignatureRequiredOverlay show={true} minHeight={810} topOffset={0} certificateExpired={certificateExpired} certificateExpiredDate={certificateExpiredDate} nationalIdMissing={nationalIdMissing} tcMismatch={tcMismatch} onMobileSignIn={mobileSignIn} mobileLoading={mobileLoading} mobileError={mobileError} />
        ) : (
        <div>
          <Grid>
            <Column className="xs-12">
              <CardContent>
                <Grid style={{ alignItems: 'center', justifyContent: 'center' }}>
                  <Column className="xs-12 sm-12 md-12 lg-12 xl-12 mb-2">
                    <TextField
                      fullWidth
                      multiline
                      rows={4}
                      variant="outlined"
                      label="Doğum Günü Mesajı"
                      placeholder="Müşterilerinize gönderilecek özel doğum günü mesajınızı yazınız..."
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      disabled={isFormDisabled || loading || fetching}
                      inputRef={messageRef}
                      helperText={
                        fetching
                          ? "Yükleniyor..."
                          : message
                            ? `${CalculateMessageCharCount(message)} karakter`
                            : "Mesajınızı yazın"
                      }
                      style={{ minHeight: 120 }}
                    />
                  </Column>
                  <Column className="xs-12 sm-12 md-12 lg-12 xl-12 mb-2">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <Button
                        title={context.t(`sms.send.autoText.nameSurname`)}
                        size="xs"
                        outlined
                        textColor="primary"
                        onClick={() => {
                          const cursorPosition = messageRef.current.selectionStart;
                          const addedMessage = `${message.slice(0, cursorPosition)} ${context.t(`sms.send.autoTextShortCode.nameSurname`)} ${message.slice(cursorPosition)}`;
                          setMessage(addedMessage);
                          messageRef.current.focus();
                        }}
                      />
                    </div>
                  </Column>
                  <Column className="xs-12 sm-12 md-12 lg-12 xl-12">
                    <Button
                      onClick={saveBirthdayMessage}
                      disabled={isFormDisabled || loading || !message.trim()}
                      backgroundColor="primary"
                      title={context.t("profile.updateButtonTitle")}
                      textColor="white"
                      fullWidth={true}
                      style={{ height: '56px', maxWidth: 200, backgroundColor: '#4caf50', color: '#fff' }}
                    />
                  </Column>
                </Grid>
              </CardContent>
            </Column>
          </Grid>
        </div>
        )}
      </div>
    </AuthContainer>
  );
};

export default BirthDaySms;